var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_vm._m(0),_c('div',{staticClass:"card-body font-weight-bold"},[_vm._v("\n\t"+_vm._s(_vm.message)+"\n\t")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-header bg-danger header-elements-inline"},[_c('h5',{staticClass:"card-title"},[_c('i',{staticClass:"fa fa-lg fa-exclamation"}),_vm._v(" Error")])])
}]

export { render, staticRenderFns }